export default "__VITE_ASSET__CTGxM_ie__"